export default {
      id: "big-arrow-down-usage",
      viewBox: "0 0 32 98",
      url: "../../assets/" + "sprite.svg#big-arrow-down-usage",
      toString: function () {
        return this.url;
      }
    }